import { Link } from "react-router-dom";

export default function CoreFeature() {

  return (
    <>
      <div class="fancy-feature-fortySix lg-container mega-feature pt-100 pt-100 pb-150 md-pt-80 lg-pb-80" id="feature">
        <div class="container">
          <div class="title-style-two text-center mb-40 md-mb-40">
            <h2>
              <span>
                Core Features of Taskflier
              </span>
            </h2>
            <div class="sub-text mt-15 maxsubtitle">
              TaskFlier offers a seamless <Link to="/"> <strong>project management system in Noida</strong></Link> tailored to meet businesses' unique needs. It's designed to help you achieve operational excellence and foster collaboration.
            </div>
          </div>
          <div class="title-style-twelve">
            <div class="row">
              <div className="col-md-12">
                <div class="item-container">

                  <div class="item"><Link class="" to="/features/task-management-software"> <i class="bi bi-list-task"></i> <span>Task Management</span> </Link></div>
                  <div class="item"><Link class="" to="/features/employee-management-software"> <i class="bi bi-person-square"></i><span>Emp Management</span></Link></div>
                  <div class="item"><Link class="" to="/features/client-management-software"> <i class="bi bi-person-check"></i> <span>Client Management</span> </Link></div>
                  <div class="item"><Link class="" to="/features/charts-reporting"> <i class="bi bi-bar-chart"></i> <span>Charts &amp; Reporting</span> </Link></div>
                  <div class="item"><Link class="" to="/features/attendance-management-software"><i class="bi bi-calendar2-check-fill"></i> <span>Attendance</span></Link></div>
                  <div class="item"><Link class="" to="/features/todo-list"><i class="bi bi-list-stars"></i><span>Todo List</span></Link></div>
                  <div class="item"><Link class="" to="/features/time-tracking-software"><i class="bi bi-alarm-fill"></i><span>Time Tracking</span></Link></div>
                  <div class="item"><Link class="" to="/features/payment-expense"><i class="bi bi-credit-card-2-back-fill"></i> <span>Payment &amp; Expense</span></Link></div>
                  <div class="item"><Link class="" to="/features/team-chat"><i class="bi bi-chat-dots-fill"></i><span>Team Chat</span></Link></div>
                  <div class="item"><Link class="" to="/features/appointment"><i class="bi bi-calendar-date-fill"></i> <span>Appointment</span></Link></div>
                  <div class="item"><Link class="" to="/features/employee-documentation"><i class="bi bi-file-earmark-text-fill"></i> <span>Emp Documentation</span></Link></div>
                  <div class="item"><Link class="" to="/features/lead-management-software"><i class="bi bi-list-ul"></i><span>Leads</span></Link></div>
                  <div class="item"><Link class="" to="/features/mobile-access"> <i class="bi bi-android2"></i> <span>Mobile Access</span></Link></div>
                  <div class="item"><Link class="" to="/features/hr-management-software"> <i class="bi bi-person-bounding-box"></i> <span>HR Management</span></Link></div>
                  <div class="item"><Link class="" to="/features/theme-customizations"><i class="bi bi-palette"></i> <span>Theme</span></Link></div>

                  <div class="item"><Link class="" ><i class="bi bi-calendar-week"></i><span>Timeline </span></Link></div>

                </div>


                <div class="d-sm-flex align-items-center justify-content-center button-group mt-4">
                  <button type="button" data-bs-toggle="modal" data-bs-target="#request-for-free-trial" class="btn-trial  btn-primary mt-10 fw-500  font-13 mb-0">


                    <span>Start your free trial</span> <i class="bi bi-stopwatch font-16"></i>


                  </button>


                </div>
                <div className="text-center pt-0 "><small className="text-primary text-center font-11">No credit card required</small></div>
              </div>

            </div>






          </div>

        </div>
      </div>
    </>
  );
}
